<div class="dialog" *ngIf="config.isVisible">
  <div class="topbar">
    <qr-button
      class="button-close"
      [config]="buttonClose"
      (click)="close()"
      matTooltip="Cerrar"
    ></qr-button>
    <h1 class="title heading-01-bold">{{ config.title }}</h1>
  </div>
  <!-- Contenido dinámico -->
  <div class="content" [ngStyle]="{ height: this.getContentHeight() }">
    <template #dinamicContainer></template>
  </div>
  <div
    class="botbar"
    *ngIf="this.config.textButtonAction || this.config.textButtonCancel"
  >
    <div class="botbar-actions">
      <qr-button
        *ngIf="this.config.textButtonCancel"
        [config]="buttonCancel"
        (click)="close()"
        class="button-cancel"
      ></qr-button>
      <qr-button
        *ngIf="this.config.textButtonAction"
        [config]="buttonAction"
        (click)="action()"
        class="button-action"
      ></qr-button>
    </div>
  </div>
</div>
